// extracted by mini-css-extract-plugin
export default {"container":"sec_1lvpm","colored":"sec_col_3GFCR"};